import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import RoleServices from "../services/RoleServices";

const Role = () => {
    const [roles, setRoles] = useState([
        { id: 1, name: "Admin" },
        { id: 2, name: "Editor" },
        { id: 3, name: "Viewer" },
    ]);
    const [newRole, setNewRole] = useState({ id: null, name: "" });
    const [editRole, setEditRole] = useState({ id: null, name: "" });
    const [showDeleteConfirmation, setShowDeleteConfirmation] = useState(null);
    const [showNotification, setShowNotification] = useState(false);
    const navigate = useNavigate();
    const url = process.env.REACT_APP_SITE_URL;

    const access = sessionStorage.getItem('access');
    const isAdmin = access && (access.includes('admin') || access.includes('Admin'));

    useEffect(() => {
        if (!isAdmin) {
            navigate('/rapport/frontend');
        }
        const fetchRoles = async () => {
            const roles = await RoleServices.getRoles();
            setRoles(roles);
        };
        fetchRoles();
    }, []);


    const handleAddRole = () => {
        if (!newRole.name) return;
        let addedRole;
        RoleServices.addRole(newRole)
            .then(data => {
                addedRole = data.role;
                setRoles([...roles, addedRole]);
                setNewRole({ id: null, name: "" });

                setShowNotification(true);
                setTimeout(() => {
                    setShowNotification(false);
                }, 3000);
            })
            .catch(error => console.error(error));
    };

    const handleEditRole = () => {
        if (!editRole.name) return;
        RoleServices.updateRole(editRole)
            .then(data => {
                const newRoles = roles.map((role) =>
                    role.id === editRole.id ? editRole : role
                );
                setRoles(newRoles);
                setEditRole({ id: null, name: "" });

                setShowNotification(true);
                setTimeout(() => {
                    setShowNotification(false);
                }, 3000);
            })
            .catch(error => console.error(error));
    };

    const handleDeleteRole = (id) => {
        RoleServices.deleteRole(id)
            .then(data => {
                setShowDeleteConfirmation(null);
                const newRoles = roles.filter((role) => role.id !== showDeleteConfirmation);
                setRoles(newRoles);

                setShowNotification(true);
                setTimeout(() => {
                    setShowNotification(false);
                }, 3000);
            }).catch(error => console.error(error));
    };

    return (
        <div className="container">
            <h1 className="my-5">Rôles</h1>
            <table className="table table-striped table-bordered table-hover table-sm">
                <thead>
                    <tr>
                        <th>#</th>
                        <th>Nom</th>
                        <th>Actions</th>
                    </tr>
                </thead>
                <tbody>
                    {roles.map((role) => (
                        <tr key={role.id}>
                            <td>{role.id}</td>
                            <td>{role.name}</td>
                            <td>
                                <div className="btn-group btn-group-sm" role="group" aria-label="Actions">
                                    <button className="btn btn-sm btn-primary" onClick={() => setEditRole(role)}
                                    >
                                        <i className="fa-solid fa-pencil"></i>
                                    </button>
                                    <button className="btn btn-sm btn-danger ml-2" onClick={() => setShowDeleteConfirmation(role.id)}>
                                        <i className="fa-solid fa-trash"></i>
                                    </button>
                                </div>
                            </td>
                        </tr>
                    ))}
                    <tr>
                        <td></td>
                        <td>
                            <input type="text" className="form-control" value={newRole.name} onChange={(e) =>
                                setNewRole({ ...newRole, name: e.target.value })
                            }
                            />
                        </td>
                        <td>
                            <button className="btn btn-success" onClick={handleAddRole}>
                                Ajouter
                            </button>
                        </td>
                    </tr>
                    {editRole.id && (
                        <tr>
                            <td>{editRole.id}</td>
                            <td>
                                <input type="text" className="form-control" value={editRole.name} onChange={(e) =>
                                    setEditRole({ ...editRole, name: e.target.value })
                                }
                                />
                            </td>
                            <td>
                                <button className="btn btn-primary" onClick={handleEditRole}>
                                    Save
                                </button>
                            </td>
                        </tr>
                    )}
                </tbody>
            </table>
            {showDeleteConfirmation && (

                <div className="modal-container">
                    <div className="modal-content">
                        <h2>Supprimer le rôle</h2>
                        <p>Voulez-vous vraiment supprimer ce rôle ?</p>
                        <div className="modal-buttons">
                            <button className="btn btn-danger" onClick={() => handleDeleteRole(showDeleteConfirmation)}
                            >
                                Supprimer
                            </button>
                            <button className="btn btn-secondary ml-2" onClick={() => setShowDeleteConfirmation(false)}
                            >
                                Annuler
                            </button>
                        </div>
                    </div>
                </div>
            )}
            {showNotification && (

                <div className="alert alert-success mt-2">Opération effectueé avec succès!</div>
            )}
        </div>
    );
};
export default Role;